import { isTauriRuntime } from '@/helpers/resolvedPlayerAppVersion'
import { getPlatform } from '@/platform'

export type TAndroidBootPowerKind = 'cold_boot' | 'app_restart'

export interface TAndroidBootPowerHints {
  hadBatteryOrPowerEvent: boolean
  bootKind: TAndroidBootPowerKind | null
  bootReason: string | null
}

function parseBootPowerHints(raw: unknown): TAndroidBootPowerHints | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const o = raw as Record<string, unknown>
  if (typeof o.hadBatteryOrPowerEvent !== 'boolean') {
    return null
  }
  const bootKindRaw = o.bootKind
  const bootKind = bootKindRaw === 'cold_boot' || bootKindRaw === 'app_restart'
    ? bootKindRaw
    : null
  const bootReason = typeof o.bootReason === 'string' && o.bootReason.trim().length > 0
    ? o.bootReason.trim()
    : null
  return {
    hadBatteryOrPowerEvent: o.hadBatteryOrPowerEvent,
    bootKind,
    bootReason
  }
}

/** Android-only: native boot power/battery hints for disruption attribution (issue #493). */
export async function fetchAndroidBootPowerHints(): Promise<TAndroidBootPowerHints | null> {
  if (!isTauriRuntime() || getPlatform() !== 'android') {
    return null
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core')
    const raw = await invoke<unknown>('plugin:lucimark-android|getBootPowerHints')
    return parseBootPowerHints(raw)
  }
  catch {
    return null
  }
}
